import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import dropdownvertical from '../assets/images/drop_vertical.svg';
import config from '../config/config';
import axios from 'axios';

const HomeHeaderDropMenu = () => {
  const [profileBannersStatus, setProfileBannersStatus] = useState('active');
  const [lockedPostsStatus, setLockedPostsStatus] = useState('active');
  const token = localStorage.getItem('token'); // Retrieve the token from local storage

  useEffect(() => {
    // Fetch user details on component mount
    axios.get(`${config.baseURL}/current-user-details`, {
      headers: {
        'Authorization': `Bearer ${token}`, // Add token to headers
      }
    })
      .then(response => {
        if (response.data.success) {
          setProfileBannersStatus(response.data.data.user_details.profile_banners);
          setLockedPostsStatus(response.data.data.user_details.locked_posts);
        }
      })
      .catch(error => {
        console.error('Error fetching user details:', error);
      });
  }, [token]);

  const handleProfileBannersToggle = () => {
    const newStatus = profileBannersStatus === 'active' ? 'inactive' : 'active';
    
    axios.post(`${config.baseURL}/update-profile-banner`, { status: newStatus }, {
      headers: {
        'Authorization': `Bearer ${token}`, // Add token to headers
        'Content-Type': 'application/json', // Optional: Specify content type
      }
    })
      .then(response => {
        if (response.data.success) {
          setProfileBannersStatus(newStatus);
          window.location.reload();   
        }
      })
      .catch(error => {
        console.error('Error updating profile banner status:', error);
      });
  };

  const handleLockedPostsToggle = () => {
    const newStatus = lockedPostsStatus === 'active' ? 'inactive' : 'active';
    
    axios.post(`${config.baseURL}/update-locked-posts`, { status: newStatus }, {
      headers: {
        'Authorization': `Bearer ${token}`, // Add token to headers
        'Content-Type': 'application/json', // Optional: Specify content type
      }
    })
      .then(response => {
        if (response.data.success) {
          setLockedPostsStatus(newStatus);
          window.location.reload();   
        }
      })
      .catch(error => {
        console.error('Error updating locked posts status:', error);
      });
  };

  

  return (
    <div className="head_dropdown">
      <ul>
        <li className="nav-item dropdown">
          <Link
            className="nav-link dropdown-toggle"            
            id="productsDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              className="icon_dropdown"
              src={dropdownvertical}
              alt=""
            />
          </Link>
          <ul
            className="dropdown-menu"
            aria-labelledby="productsDropdown"
          >
            <li className="dropdown">
              <Link 
                className="dropdown-item"                
                onClick={handleLockedPostsToggle}
              >
                {lockedPostsStatus === 'active' ? 'Hide all Locked Posts' : 'Show all Locked Posts'}
              </Link>
            </li>
            <li className="dropdown">
              <Link 
                className="dropdown-item"                
                onClick={handleProfileBannersToggle}
              >
                {profileBannersStatus === 'active' ? 'Hide the Profile Banners' : 'Show the Profile Banners'}
              </Link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default HomeHeaderDropMenu;
